import { useIntl } from "react-intl";
import BigNumberCard from "./BigNumberCard";

export type BigNumberSupport =
  | "all"
  | "OPEN" | "IN_ANALYSIS" | "ANSWERED" | "FINISHED"

interface Props {
    pending: number;
    analyze: number;
    dealer: number;
    finished: number;
    selected: BigNumberSupport;
    handleType: (type: BigNumberSupport) => void;
}

const ListBigNumber = ({ pending, analyze, dealer, finished, handleType , selected}: Props) => {
    const intl = useIntl();
    const toogle = (type: BigNumberSupport) => {
        handleType(type === selected ? "all" : type);
    }
    return (
        <div className="display-flex justify-content-center gap-5">
            <BigNumberCard
                active={selected}
                total={pending}
                type="OPEN"
                title={intl.formatMessage({ id: "intl-msg:tas.occurrence.card.open" })}
                toogle={() => toogle('OPEN')}
                description={intl.formatMessage({ id: "intl-msg:support.listBigNumber.pendingDescription" })}
            />
            <BigNumberCard
                active={selected}
                total={analyze}
                type="IN_ANALYSIS"
                title={intl.formatMessage({ id: "intl-msg:tas.occurrence.card.inAnalysis" })}
                toogle={() => toogle('IN_ANALYSIS')}
                description={intl.formatMessage({ id: "intl-card:tas.analysis.description" })}
            />
            <BigNumberCard
                active={selected}
                total={dealer}
                type="ANSWERED"
                title={intl.formatMessage({ id: "intl-msg:tas.occurrence.card.answered" })}
                toogle={() => toogle('ANSWERED')}
                description={intl.formatMessage({ id: "intl-card:tas.dealer.description" })}
            />
            <BigNumberCard
                active={selected}
                total={finished}
                type="FINISHED"
                title={intl.formatMessage({ id: "intl-card:tas.finished.title" })}
                toogle={() => toogle('FINISHED')}
                description={intl.formatMessage({ id: "intl-card:tas.finished.description" })}
            />
        </div>
    );
};

export default ListBigNumber;
